 // export const domain = "http://ncd.ddc.moph.go.th/satsystem/public/api";
// export const domain = "http://127.0.0.1:8000/api";
export const domain = "https://forensic-admin.kisrasprint.com/api";
// export const domain = "https://satsystem.famikinnovation.com/api";
